import { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setSuspensionType } from 'store/user/actions';
import { SUSPENSION_TYPES } from 'store/user/reducer.types';
import {
    selectIfCollectionSuspensionActive,
    selectValidSubscriptions,
} from 'store/user/selectors';

function useCollectionSuspension() {
    const dispatch = useDispatch();

    const validSubscriptions = useSelector(selectValidSubscriptions);
    const collectionSuspensionActive = useSelector(
        selectIfCollectionSuspensionActive,
    );

    const prevCollectionSuspensionActive = useRef(collectionSuspensionActive);
    const prevValidSubscriptions = useRef(validSubscriptions);

    useEffect(() => {
        const prev = prevCollectionSuspensionActive.current;
        const next = collectionSuspensionActive;

        // Avoid suspension activation on initial entitlements loading request.
        if (
            prev !== next &&
            prevValidSubscriptions.current.length &&
            validSubscriptions.length
        ) {
            dispatch(setSuspensionType(SUSPENSION_TYPES.COLLECTION));
        }

        prevCollectionSuspensionActive.current = collectionSuspensionActive;
        prevValidSubscriptions.current = validSubscriptions;
    }, [collectionSuspensionActive, validSubscriptions]);
}

export default useCollectionSuspension;
